import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import BigNumber from 'bignumber.js';
import { PricelistApis } from '../../../../../../../hooks/apis/PricelistApis';
import { ITrackingAnalysis } from '../../../../../../../interfaces/Pricelist/ITrackingAnalysis';

const TrackingAnalysisDetails = ({ trackingAnalysis }) => {
  const { getTrackingAnalysisDetails } = PricelistApis();
  const [error, setError] = useState('');
  const [trackingDetails, setTrackingDetails] = useState<ITrackingAnalysis | undefined>();

  useEffect(() => {
    getTrackingAnalysisDetails(trackingAnalysis)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setTrackingDetails(data);
        }
      })
      .catch((e) => setError(e));
  }, [trackingAnalysis, getTrackingAnalysisDetails]);

  return (
    <Box className="trackingDetails">
      {error && !trackingDetails ? <Box className="errorBox">{error}</Box> : null}
      {!error && !trackingDetails ? <Box><h2>Loading Tracking Info...</h2></Box> : null}
      {trackingDetails ?
      <>
        <h2>{trackingDetails.Description}</h2>
        <p>
          <span>Code:</span> {trackingDetails.Code}
        </p>
        <p>
          <span>Price:</span> ${new BigNumber(trackingDetails.Price).dp(2, BigNumber.ROUND_HALF_UP).toFixed(2)}
        </p>
        <p>
          <span>Supplied By:</span> {trackingDetails.SuppliedBy}
        </p>
      </> : null}
    </Box>
  )
};

export default React.memo(TrackingAnalysisDetails);
